import angular, { IComponentController, ILogService, IOnChangesObject, IQService, ITimeoutService } from 'angular'
import { AsyncFilter, FileItem, FileUploader, FileUploaderFactory, SyncFilter } from 'angular-file-upload'
import { values } from 'lodash'
import { AccesoDatos, BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'
import { DocsCV, TGrupoDocCv } from 'src/_candidato/data/DocsCV'
import { IGrupoDoc, ITipoDoc, TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import {
  IAccionCV,
  IAccionCvDataNotif,
  IEstadoCvNotifStore,
  IEstadoCvNotifStoreItem,
  IFilaCV,
  IModelAccion,
  IModelDocInterno,
  IModelRespuestaHistCV,
  IRegistrosCoincidenciasPreg,
  IReporteCV,
  IReporteCVHistorico,
  IResultadoAccionCV,
  IResultadoDocInternoCV,
} from 'src/model/candidato-api'

class PanelCvComponentCtrl implements IComponentController {
  cv!: IFilaCV
  tipos!: TiposDocEstadosStore
  onUpdateAccion!: (arg0: { data: IResultadoAccionCV }) => void
  showHistory!: boolean
  showDocs!: boolean
  editHistory!: boolean
  editDocs!: boolean
  hidePrint!: boolean
  hidePdf!: boolean

  baseUrlApiPriv = `${BASE_CANDIDATO_API}api/priv`

  permitedocs = false

  verEstruct = false

  report: IReporteCV
  historyMatch = {
    tiene: false,
    list: [] as MatchEnHist[],
  }

  $loading = false

  history = {
    add: {
      active: false,
      text: '',
      state: null as CVState,
      dataNotif: null as IAccionCvDataNotif,
      $loading: false,
    },
    list: [] as IModelAccion[],
  }

  internaldoc = {
    add: {
      active: false,
      doc: null as CVInternalDoc,
      tipo: null as string,
      $loading: false,
      $pristine: true,
    },
    showall: false,
    docs: new DocsCV(),
  }

  statesStore: IEstadoCvNotifStore
  statesStoreCvList: CVState[] = []
  tiposDocGruposList: IGrupoDoc[]

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private NotifService: NotificacionService,
    private $q: IQService,
    private AccesoDatos: AccesoDatos,
    private FileUploader: FileUploaderFactory
  ) {}

  $onInit(): void {
    this.$log.info('[PanelCvComponentCtrl] onInit')

    // valores por defecto
    this.showHistory = this.showHistory ?? true
    this.showDocs = this.showDocs ?? true
    this.editHistory = this.editHistory ?? true
    this.editDocs = this.editDocs ?? true
    this.hidePrint = this.hidePrint ?? false
    this.hidePdf = this.hidePdf ?? false
  }

  $onChanges(obj: IOnChangesObject) {
    if (obj && obj.cv) {
      this.report = null
      this.history.add.active = false
      this.history.add.state = null
      this.history.add.text = ''

      this.internaldoc.add.active = false
      this.internaldoc.add.doc = null
      this.internaldoc.add.tipo = null

      if (obj.cv.currentValue) this._leerCV()
    }

    if (obj.tipos && obj.tipos.currentValue) {
      this.$log.info('----> tipos!!!')

      this.tiposDocGruposList = this.tipos.gruposDocList()
      this.statesStore = this.tipos.estadosStore()
      this.internaldoc.docs.updateTipos(this.tipos)
    }
  }

  private _leerCV() {
    this.permitedocs = false
    this.$loading = true
    this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then((reportResponse) => {
      this.report = reportResponse
      this.history.list = reportResponse.history.list
      this.internaldoc.docs.updateDocs(reportResponse.docs)

      this.__initAllowedStates(this.statesStore, reportResponse)

      this.permitedocs = reportResponse.form.permiteDocs

      this.historyMatch = {
        tiene: reportResponse.coincidenciasHist.tieneMatch,
        list: values(reportResponse.coincidenciasHist.registrosHistPorPreg).map((r) => new MatchEnHist(r)),
      }

      this.$loading = false
    })
  }

  _refreshcv() {
    this.report = null

    this._leerCV()
  }

  _leerCVHist(match: MatchEnHist, resp: RespMatch) {
    if (resp.report) {
      resp.report = null
      return
    }

    match.$loading = true
    this.AccesoDatos.HistoricCurr_CLIENT.datosCvHistorico(resp.resp.cv_id_historic) //
      .then((reportResponse) => {
        resp.report = reportResponse
        match.$loading = false
      })
  }

  private __initAllowedStates(stados: IEstadoCvNotifStore, reporte: IReporteCV) {
    this.statesStoreCvList = stados.list.map((st) => new CVState(st, reporte))
  }

  newHistory() {
    this.history.add.active = !this.history.add.active

    if (this.history.add.active) {
      this.history.add.dataNotif = {
        comite_autoriza: null,
        comite_puesto: null,
      }
      this.$timeout(() => {
        ;(this.$element.find('select') as any).formSelect()

        this.$element.find('textarea').trigger('focus')
      }, 1)
    }
  }

  addHistory() {
    this.history.add.$loading = true

    // validar el required
    if (this.history.add.state.st.notificar && this.history.add.state.st.estadoComite) {
      if (!this.history.add.dataNotif.comite_autoriza || !this.history.add.dataNotif.comite_puesto) {
        this.NotifService.errorMsg('Please fill all required fields')
        this.history.add.$loading = false
        return
      }
    }

    this.AccesoDatos.GestionCurr_CLIENT.nuevaAccionParaCV(this.cv.cv.idcv, this._generaAccion())
      .then((accionResponse) => {
        // incluir la nueva acción en la lista
        this.history.list.unshift(accionResponse.actionitem)

        this.history.add.active = false

        this.onUpdateAccion({ data: accionResponse })
      })
      .finally(() => (this.history.add.$loading = false))
  }

  private _generaAccion() {
    let accion: IAccionCV = {
      state: this.history.add.state.st.estado,
      notas: this.history.add.text,
      dataNotif: null,
    }

    if (this.history.add.state.st.estadoComite) {
      accion.dataNotif = this.history.add.dataNotif
    }

    return accion
  }

  newInternalDoc() {
    // inicializar el uploader
    if (!this.internaldoc.add.active) {
      this.internaldoc.add.doc = new CVInternalDoc(this.initFileUpload())
    }

    this.internaldoc.add.active = !this.internaldoc.add.active

    if (this.internaldoc.add.active)
      this.$timeout(() => {
        this.internaldoc.add.$pristine = true
        this.internaldoc.add.$loading = false
        ;(this.$element.find('select') as any).formSelect()
      }, 1)
  }

  async addInternalDoc() {
    if (this.internaldoc.add.$loading || this.internaldoc.add.$pristine) {
      return
    }

    let files = this.internaldoc.add.doc.filesEnviar()

    if (!files.length) return

    this.internaldoc.add.$loading = true

    let url = encodeURI(`${this.baseUrlApiPriv}/_cv/cv/${this.cv.cv.idcv}/idoc`)

    for (const file of files) {
      await this.enviafile(file, this.internaldoc.add.doc, url)
    }

    this.$timeout(() => {
      this.internaldoc.add.$loading = false
      this.internaldoc.add.active = false
    }, 200)
  }

  private initFileUpload() {
    let __self = this

    let uploader = new this.FileUploader({
      // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
      //,timeout: 2000
    })

    // uploader.url = BASE_CANDIDATO_API + "api/_cv/n/abc/f"

    // FILTERS

    // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        console.log('syncFilter')
        return this.queue.length < 10
      } as SyncFilter,
    })

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
        console.log('asyncFilter')
        setTimeout(deferred.resolve, 1e3)
      } as AsyncFilter,
    })

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
      console.info('onWhenAddingFileFailed', item, filter, options)
    }
    uploader.onAfterAddingFile = function (fileItem) {
      if (uploader.queue.length > 1) {
        uploader.removeFromQueue(0)
      }

      console.info('onAfterAddingFile', fileItem)
      console.info('onAfterAddingFile', uploader.queue)

      __self.$timeout((_) => {
        __self.internaldoc.add.$pristine = false
      })
    }
    uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll', addedFileItems)
    }
    uploader.onBeforeUploadItem = function (item: FileItem) {
      console.info('onBeforeUploadItem', item)

      var f = new FormData()

      f.append('foo', '2')

      item.formData.push(f)
    }
    uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem', fileItem, progress)
    }
    uploader.onProgressAll = function (progress) {
      console.info('onProgressAll', progress)
    }
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers)
    }
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers)
    }
    uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers)
    }
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      console.info('onCompleteItem', fileItem, response, status, headers)
    }

    uploader.onCompleteAll = () => {
      console.info('onCompleteAll')
    }

    console.info('uploader', uploader)

    return uploader
  }

  testUpload() {
    let _up = new this.FileUploader({
      // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
      //,timeout: 2000
    })

    this.$log.debug('test uploader', _up.queue)

    _up.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

    let idx = 0
    _up.queue.forEach((f) => {
      f.onComplete = (response, status, headers) => {
        this.$log.debug('Complete!!!!!', status)
      }

      var fd = new FormData()

      fd.append('idx', '' + idx++)

      f.formData = [fd]

      f.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

      _up.uploadItem(f)
    })
  }

  private enviafile(f: FileItem, cvpreg: CVInternalDoc, url: string) {
    let $p = this.$q.defer()

    f.url = url
    f.formData = [this._formDataPreg(f, cvpreg)]
    f.onSuccess = (response, status, headers) => {
      let result = response as unknown as IResultadoDocInternoCV

      console.log('complete!!!!')

      // incluir los datos en la lista
      this.$timeout(() => {
        this.internaldoc.docs.nuevoDoc(result.item)
      })
    }

    f.onComplete = (response: Response, status: number) => {
      if (status != 200) {
        this.NotifService.alert('Failed to save document')
      }

      $p.resolve()
    }

    f.upload()

    return $p.promise
  }

  private _formDataPreg(f: FileItem, cvpreg: CVInternalDoc) {
    let fd = new FormData()
    fd.append('__idcv', '' + this.cv.cv.idcv)
    fd.append('name', f.file.name)
    fd.append('tipo', this.internaldoc.add.tipo)

    if (cvpreg.tipo) fd.append('tipo', cvpreg.tipo?.tipo)

    return fd
  }

  borrarDocInterna($grupo: TGrupoDocCv, $doc: IModelDocInterno) {
    if (confirm('Please confirm you want to delete the file \n\n **** File contents cannot be recovered *** \n\n ')) {
      this.AccesoDatos.GestionCurr_CLIENT.borrarDocInterno(this.cv.cv.idcv, $doc.iddocint, { f: $doc.name }).then(
        (borrarResponse) => {
          if (borrarResponse) {
            this.internaldoc.docs.quitarDocDeGrupo($grupo, $doc)
          }
        }
      )
    }
  }
}

angular.module('candidato').component('panelCv', {
  bindings: {
    cv: '<',
    tipos: '<',
    showHistory: '<',
    showDocs: '<',
    editHistory: '<',
    editDocs: '<',
    hidePrint: '<',
    hidePdf: '<',
    onUpdateAccion: '&',
  },
  controller: PanelCvComponentCtrl,
  template: require('./panel-cv.component.html'),
})

export class CVInternalDoc {
  uploader: FileUploader
  tipo: ITipoDoc

  constructor(_uploader: FileUploader) {
    this.uploader = _uploader
  }

  filesEnviar() {
    let _list = this.uploader.queue

    if (!_list.length) {
      console.warn('No hay files para enviar!!!!')
    }

    return _list
  }
}

export class CVState {
  tieneReglas = false
  permitido = false

  displayHtml: string
  displayIcon: string

  title = ''

  constructor(
    public st: IEstadoCvNotifStoreItem,
    reporte: IReporteCV
  ) {
    let reglEstado = reporte.regld.reglasPorEstado[st.estado.estado]

    this.tieneReglas = !!(reglEstado && reglEstado.regl.length)
    this.permitido = !this.tieneReglas || reglEstado.permited

    if (!this.permitido) {
      this.title = 'Required docs not satisfied'
      this.displayHtml = `<span title="${this.title}">${st.estado.texto_en} - ${st.estado.texto_es}</span><br/><span class="text-sm text-muted">(required docs not completed)</span>`

      // si el estado no está permitido, incluir no permitido
      this.displayIcon = '/candidato/images/errorc3.png'
    } else this.displayHtml = `<span title="${this.title}">${st.estado.texto_en} - ${st.estado.texto_es}</span>`
  }
}

type RespMatch = {
  report?: IReporteCVHistorico
  resp: IModelRespuestaHistCV
}

export class MatchEnHist {
  $loading = false

  readonly resplist: RespMatch[]

  constructor(public data: IRegistrosCoincidenciasPreg) {
    this.resplist = data.regs.map(
      (resp) =>
        ({
          resp,
        }) satisfies RespMatch
    )
  }
}
